import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetLeaveCategoryModel } from "@core/model/query-model-leave-category";
import { leaveCategoryFormDefault } from "./form.default";
import { LeaveCategoryFormSchema } from "./form.rule";

export const useFormDefaultLeaveCategory = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetLeaveCategoryModel | undefined) => {
    return !cachedValue
      ? leaveCategoryFormDefault
     : ({
        name: cachedValue.name,
        description: cachedValue.description,
      } as LeaveCategoryFormSchema);
  };

  return {
    getDefault,
  };
};
